<script setup lang="ts">
const emit = defineEmits(["2FASubmitted", "toggleModalLock"]);

defineProps({
  loaderTitle: {
    type: String,
    default: "",
  },
  loaderBodyTitle: {
    type: String,
    default: "",
  },
  loaderBodySubtitle: {
    type: String,
    default: "",
  },
});

const userStore = useUserStore();
const { toaster } = useToaster();
const { request2FA } = useAuthController();
const isLoading = ref(false);
const isModalLoaderShown = ref(false);

const resend2FA = async () => {
  const res = await request2FA();
  if (res && res.statusCode !== 200) {
    toaster("error", "code2FARequestFail");
  }
};

const check2FA = async (code: string = "") => {
  isLoading.value = true;
  setTimeout(() => {
    isModalLoaderShown.value = true;
  }, 1000);
  emit("2FASubmitted", code);
};

onMounted(() => {
  emit("toggleModalLock");
});

watch(isModalLoaderShown, (newVal) => {
  if (newVal) emit("toggleModalLock");
});
</script>
<template>
  <ModalLoader
    v-if="isModalLoaderShown"
    :title="loaderTitle"
    :body-title="loaderBodyTitle"
    :body-subtitle="loaderBodySubtitle" />
  <div v-else>
    <div class="text-neutral-300">
      <p class="font-light">
        {{ $t("main.modal2FA.need2FACode") }}
      </p>
      <p class="font-light">
        {{ $t("main.modal2FA.emailSent") }}
        <span class="font-bold underline">{{ userStore.email }}</span
        >.
      </p>
    </div>
    <BaseInput2FA @resend="resend2FA" @send-code="check2FA" />
  </div>
</template>
